import { Component, h, State, Build } from '@stencil/core';
import { createRouter, Route, match } from 'stencil-router-v2';
import get from 'lodash/get'
import inRange from 'lodash/inRange'

import { locales } from '../../shared/config'
import state from '../../store/store';
import { getWebsite } from '../../shared/api'
import { SectionFooter, SectionHeader, SectionHeaderMobile, AppRTE } from '../../functional'

declare var UIkit;
declare var window;

const Router = createRouter();
@Component({
  tag: 'app-root',
})
export class AppRoot {

  @State() searchParams: any = {};

  private header: any;
  private footer: any;

  async componentWillLoad() {

    // match locale
    const language = window.navigator.language || 'en-GB'
    const locale = locales.includes(language) ? language : locales.includes(language.split('-')[0]) ? language.split('-')[0] : null

    // get media size
    const mediaSizes = [{ s: 0, e: 639, l: 's' }, { s: 640, e: 959, l: 'm' }, { s: 960, e: 1199, l: 'l' }, { s: 1200, e: 1599, l: 'xl' }, { s: 1600, e: 99999, l: 'xxl' }]
    let mediaSize = 's'
    for (let i = 0; i < mediaSizes.length; i++) {
      const { s, e, l } = mediaSizes[i];
      mediaSize = l
      if (inRange(window.innerWidth, s, e)) break;
    }


    // get feature support
    let BarcodeDetector = true;
    if (!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
      console.warn('BarcodeDetector: Not Supported')
      BarcodeDetector = false
    }


    state.browser = {
      width: window.innerWidth,
      mediaSize,
      locale,
      BarcodeDetector
    };

    const data: any = await getWebsite(locale)

    this.header = get(data, 'data.data.attributes.Header')
    this.footer = get(data, 'data.data.attributes.Footer')
    state.website = get(data, 'data.data.attributes')
    state.Router = Router;
    this.searchParams = Router.url.searchParams

    this.header.Notification = get(state.website, 'Notification');
    this.header.TopLinks = get(state.website, 'TopLinks');

    // remove dup og tags
    const script = document.querySelector('script[type="application/ld+json"]')
    if (script) script.parentNode.removeChild(script);

    const el = this;
    Router.onChange('url', (newValue: any, _oldValue: any) => {
      const { searchParams } = newValue;
      el.searchParams = searchParams;

      // remove dup og tags
      const script = document.querySelector('script[type="application/ld+json"]')
      if(script) script.parentNode.removeChild(script);

      // if (window.gtag) window.gtag("config", "UA-3722964-1");
    });
  }

  componentDidLoad() {
    if (Build.isBrowser) {
      
      if (this.header.Notification) {
        try {
          window.addEventListener("scroll", () => {
            UIkit.modal('#modal-notification').show();
          }, { once: true });
        }
        catch (err) {
          console.error(err)
        }
      }
    }
  }

  render() {

    return [
      <SectionHeader data={this.header} />,
      <SectionHeaderMobile data={this.header} />,
      <div style={{ 'min-height': 'calc(100vh - 176px)' }}>
        <Router.Switch>
          <Route path="/" render={() => <vw-page slug='' />} />

          {/* entry for non-ssg pages */}
          <Route path="/app" render={<div></div>} />

          <Route path={match('/owners/:slug')}
            render={({ slug }) => <vw-page list='owners' slug={slug} />}
          />

          <Route path={match('/news/:slug')}
            render={({ slug }) => 
              !isNaN(slug as any) ?
                <vw-list slug='news' page={Number(slug)} searchParams={this.searchParams} title={get(state, 'website.NewsTitle')} description={get(state, 'website.NewsDescription')} pagesize={get(state, 'website.NewsMaxResults')} filterOptions={get(state, 'website.NewsFilters.data')} />
                : 
            <vw-page list='news' slug={slug} />}
          />

          <Route path={match('/events/:slug')}
            render={({ slug }) => 
              !isNaN(slug as any) ?
                <vw-list slug='events' page={Number(slug)} searchParams={this.searchParams} title={get(state, 'website.EventsTitle')} description={get(state, 'website.EventsDescription')} pagesize={get(state, 'website.EventsMaxResults')} filterOptions={get(state, 'website.EventsFilters.data')} />
                : 
            <vw-page list='events' slug={slug} />
          }
          />

          <Route path={match('/videos/:slug')}
            render={({slug}) => <vw-list slug='videos' page={Number(slug)} searchParams={this.searchParams} title={get(state, 'website.VideosTitle')} description={get(state, 'website.VideosDescription')} pagesize={get(state, 'website.VideosMaxResults')} filterOptions={get(state, 'website.VideosFilters.data')} />}
          />

          <Route path={match('/news')}
            render={() => <vw-list slug='news' searchParams={this.searchParams} title={get(state, 'website.NewsTitle')} description={get(state, 'website.NewsDescription')} pagesize={get(state, 'website.NewsMaxResults')} filterOptions={get(state, 'website.NewsFilters.data')} />}
          />

          <Route path={match('/events')}
            render={() => <vw-list slug='events' searchParams={this.searchParams} title={get(state, 'website.EventsTitle')} description={get(state, 'website.EventsDescription')} pagesize={get(state, 'website.EventsMaxResults')} filterOptions={get(state, 'website.EventsFilters.data')} />}
          />

          <Route path={match('/videos')}
            render={() => <vw-list slug='videos' searchParams={this.searchParams} title={get(state, 'website.VideosTitle')} description={get(state, 'website.VideosDescription')} pagesize={get(state, 'website.VideosMaxResults')} filterOptions={get(state, 'website.VideosFilters.data')} />}
          />

          <Route path={match('/:slug')}
            render={({ slug }) => <vw-page slug={slug} />}
          />

        </Router.Switch>
      </div>,
      <SectionFooter data={this.footer} />,
      <div id="modal-notification" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-background-primary-striped uk-light uk-padding">
          <button class="uk-modal-close-default" type="button" uk-close></button>
          <AppRTE className='wsio-p-condense' markdown={this.header.Notification} />
        </div>
      </div>
    ];
  }
}
